import { render, staticRenderFns } from "./Affiliations.vue?vue&type=template&id=5f4804c3&scoped=true"
import script from "./Affiliations.vue?vue&type=script&lang=js"
export * from "./Affiliations.vue?vue&type=script&lang=js"
import style0 from "./Affiliations.vue?vue&type=style&index=0&id=5f4804c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4804c3",
  null
  
)

export default component.exports